var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-10 px-2 mb-6 flex items-center rounded text-lg bg-gray-100 text-gray-600 font-medium border border-gray-400"},[_c('span',[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }